<template>
  <div>
    <section v-if="content.body.length">
      <template v-if="content.title != null">
        <div class="mb-2">
          <div class="d-flex">
            <div class="flex-grow-1">
              <div class="headline" v-text="content.title"></div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="!gridMode">
        <v-slide-group v-model="selected" :show-arrows="true">
          <v-slide-item
            v-for="(item, idx) of content.body"
            :key="`grade_${idx}`"
            v-slot:default="{ active }"
          >
            <v-hover v-slot:default="{ hover }">
              <v-sheet
                v-ripple
                class="hoverable card-growable ma-2 pa-3"
                :width="200"
                @click="navigate(item)"
                :elevation="hover ? 2 : 1"
                :color="hover || active ? 'primary--text' : ''"
              >
                <v-row align="center" no-gutters>
                  <v-col class="grow">
                    <div
                      class="font-weight-bold subtitle-1 text-overflow"
                      v-text="item.title"
                    ></div>
                  </v-col>
                  <!-- <v-col class="shrink">
                  <v-icon :color="hover || active? 'primary':''">far fa-search</v-icon>
                </v-col>-->
                </v-row>
              </v-sheet>
            </v-hover>
          </v-slide-item>
        </v-slide-group>
        <template v-if="content.footerButton != null">
          <div class="mt-3">
            <v-btn :color="$buttonColor">
              {{ $vuetify.lang.t("$vuetify.actions.more") }}
              <v-icon right small>far fa-chevron-right</v-icon>
            </v-btn>
          </div>
        </template>
      </template>
      <template v-else>
        <v-item-group>
          <template v-for="(item, idx) of content.body">
            <v-item :key="`grade_${idx}`">
              <v-hover v-slot:default="{ hover }">
                <v-sheet
                  v-ripple
                  class="hoverable card-growable ma-2 pa-3"
                  :elevation="hover ? 2 : 1"
                  :color="hover ? 'primary--text' : ''"
                  @click="navigate(item)"
                >
                  <v-row align="center" no-gutters>
                    <v-col class="grow">
                      <div
                        class="font-weight-bold subtitle-1 text-overflow"
                        v-text="item.title"
                      ></div>
                    </v-col>
                    <!-- <v-col class="shrink">
                    <v-icon :color="hover? 'primary':''">far fa-search</v-icon>
                  </v-col>-->
                  </v-row>
                </v-sheet>
              </v-hover>
            </v-item>
          </template>
        </v-item-group>
      </template>
    </section>
    <section v-else>
      <div class="mb-2">
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="headline" v-text="content.title"></div>
          </div>
        </div>
      </div>
      <v-row class="px-2 mb-4 text-center body-2 grey--text">
        <v-col cols="12"> ไม่มีข้อมูล </v-col>
      </v-row>
    </section>
  </div>
</template>

<script>
export default {
  name: "grade_horizontal_listview",
  props: ["content", "grid"],
  data: () => ({
    selected: null,
  }),
  computed: {
    gridMode() {
      if (this.grid == undefined) {
        return false;
      } else {
        if (this.grid === "" || this.grid === null) {
          return true;
        } else {
          return this.grid;
        }
      }
    },
  },
  methods: {
    navigate(item) {
      this.$router.push({
        name: "course",
        query: {
          grade: item._id,
          page: 1,
          limit: 10,
          sort: "created_at",
          sortBy: -1,
        },
      });
    },
  },
};
</script>